import {
  Autocomplete,
  Box,
  Button,
  Container,
  Divider,
  Stack,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect, useState } from "react";
import Attendee from "./Attendee";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from 'axios';
import { BaseHrmUrl } from "../../Intro/Constants";

function Attendance() {
  const [value, setValue] = useState(null);
  const [people, setListofPeople] = useState(null);
  const departments = ["Office", "Outsource"];
  const stations = ["Kitale", "Bungoma", "Kakamega", "Eldoret", "Kismumu"];
  const towns = [];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await axios.get(`${BaseHrmUrl}/attendance/`);
        if (response.status === 200) {  
          setListofPeople(response.data);
        }
         else {
          alert("Failed! Try again.");
        }
      } catch (error) {
        alert("Error fetching contacts, No internet?");
      }
    };
    loadData()}, []);

  const getTowns = () => {
    const towns = new Set();
    if (people) {
      people.forEach((person) => {
        if ((person.towns !== "") & (person.town !== null)) {
          towns.add(person.town);
        }
      });
      return Array.from(towns);
    }
  };

  const handleTownChange = (ev, val) => {
    const curr_people = people.filter((person) => {
      return person.town === val ? true : false;
    });
    setListofPeople(curr_people);
  };

  const handleSubmit = (curr_user) => {
    const marked_people = people.map((indiv) => {
      if (indiv.user.username === curr_user.user.username) {
        return curr_user;
      } 
      else {
        return indiv;
      }
    });
    console.log(marked_people);
    
    setListofPeople(marked_people);
  };
  return (
    <>
      <Zoom in={true} style={{ transitionDelay: "200ms" }}>
        <Stack>
          <Box
            display={"flex"}
            my={1}
            flexDirection={{ xs: "column", sm: "column", md: "row" }}
            rowGap={1}
            alignItems={"center"}
          >
            <Typography variant="h6">Attendance</Typography>
            <Box display={"flex"} ml={"auto"}>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Container components={["DatePicker"]}>
                  <DatePicker
                    value={value}
                    onChange={(newValue) => setValue(newValue)}
                  />
                </Container>
              </LocalizationProvider> */}
            </Box>
          </Box>

          <Divider variant="middle" />
          <Box
            display={"flex"}
            columnGap={2}
            mt={3}
            flexDirection={{ xs: "column", sm: "column", md: "row" }}
            rowGap={1}
          >
            <Autocomplete
              disablePortal
              options={getTowns()}
              sx={{ width: 300}}
              onChange={(ev, val) => handleTownChange(ev, val)}
              renderInput={(params) => (
                <TextField {...params} label="Town" size="small" sx={{borderRadius:4}} />
              )}
            />
            <Autocomplete
              disablePortal
              options={departments}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Department" size="small" />
              )}
            />
            <Autocomplete
              disablePortal
              options={stations}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Station" size="small" />
              )}
            />
          </Box>
          <Box
            display={"flex"}
            columnGap={1}
            flexDirection={{ xs: "column", sm: "column", md: "row" }}
            rowGap={1}
          >
            <Grid container spacing={2}>
              {people ? (
                people.map((person) => {
                  return (
                    <Grid size={{xs:6,sm:6, md:4, lg:3}} key={person}>
                      <Attendee person={person} submit={handleSubmit} />
                    </Grid>
                  );
                })
              ) : (
                <Typography variant="h6">Register is empty</Typography>
              )}
            </Grid>
          </Box>
          <Box display={"flex"} mt={2}></Box>
        </Stack>
      </Zoom>
    </>
  );
}

export default Attendance;

